// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__FXMNw","heading":"styles_heading__iYwdr","tags":"styles_tags__JSoSr","tag":"styles_tag__jReuy","loader":"styles_loader__DvKCl"};